<div #focusElement [id]="id"
      class="eui-icon-toggle {{stateClass}} {{styleClass}}"
      tabindex="{{!isReadOnly ? tabindex: '-1'}}"
      role="switch"
      [attr.aria-label]="ariaLabel"
      [attr.aria-checked]="isChecked"
      [attr.accesskey]="keyboardAccessKey"
      (click)="onToggle()"
      (keydown)="onKeyDown($event)">
    <span class="eui-icon-toggle__icon eui-icon {{iconClass}}"  [class.eui-icon-toggle--checked]="isChecked" [class.eui-u-cursor-pointer]="!isReadOnly"></span>
</div>
